import { useBlocker } from "react-router";
import { useEffect } from "react";

export function NavigationBlocker(handler, when) {
  const blocker = useBlocker(when);

  useEffect(() => {
    if (blocker.state === "blocked") {
      handler({
        location: blocker.location,
        retry: blocker.proceed,
        reset: blocker.reset,
      });
    }
  }, [blocker, handler]);
}
